import React, { useState, useEffect } from "react";

import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
import useEncryption from "../useEncryption/useEncryption";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import DocxConverter from "../DocxConverter/DocxConverter";
import * as mammoth from "mammoth/mammoth.browser.js";
import DocxConverterEdit from "../DocxConverter/DocxConverterEdit";
import { HiDownload } from "react-icons/hi";
import { PropagateLoader } from "react-spinners";

const Forms = () => {
  const { decryptData } = useEncryption();

  const [showAll, setShowAll] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const [allForms, setAllForms] = useState([]);
  const [docxContent, setDocxContent] = useState("");
  const [docxContentEdit, setDocxContentEdit] = useState("");

  const [file, setFile] = useState(null);
  const [savedContent, setSavedContent] = useState("");
  const [savedContentEdit, setSavedContentEdit] = useState("");
  const [mytemplateIDData, setMytemplateIDData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [add, setadd] = useState(false);
  const [second, setSecond] = useState(false);
  const [dateVersionDocx, setDateVersionDocx] = useState();
  const [allViewForm, setAllViewForm] = useState([]);

  useEffect(() => {
    if (isLoading === true) {
      const loadingTimeout = setTimeout(() => {
        setIsOpenEdit(true);
        getViewallSubmitForm();
        getFormsData();
        setIsLoading(false);
      }, 2000);
      return () => {
        clearTimeout(loadingTimeout); // Clear the timeout if the component unmounts
      };
    }
  }, [isLoading]);

  // Get All Forms Templete Show
  const getFormsData = async (title) => {
    await axiosInstanceAuth
      .post(`/get_allform`, { name: title })
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllForms(myData?.data?.Forms);
        // console.log("FormsData---->", myData?.data?.Forms);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const handleFileUploadEdit = (file) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const htmlFile = event.target.result;
      setMytemplateIDData(htmlFile);
      setDocxContentEdit(htmlFile);
    };
    reader.readAsText(file);
  };

  const [getId, setGetId] = useState("");

  const getFormsIDApi = async (getId) => {
    setGetId(getId);
    setDocxContentEdit("");
    setSavedContentEdit("");
    await axiosInstanceAuth
      .get(`/get_singleForm/${getId}`)
      .then((res) => {
        const myTemplateID = decryptData(res?.data?.data);
        // setMytemplateIDData(myTemplateID)
        setDateVersionDocx(myTemplateID);

        if (myTemplateID?.data?.submitedHtml) {
          getFormsEditApi(myTemplateID?.data?._id);
        } else {
          const fileUrl = `${BACKEND_BASE_URL}${myTemplateID?.data?.FormPath}`;
          console.log("FileURl---->", fileUrl);
          fetch(fileUrl)
            .then((res) => res.blob())
            .then((blob) => {
              console.log(myTemplateID?.data?.submitedHtml);
              const file = new File([blob], myTemplateID.fileName, {
                type: blob.type,
              });
              if (myTemplateID?.status) {
                setadd(true);
              }
              setFile(file);
              handleFileUpload(file);
            });
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Get All recent Data Show

  const getViewallSubmitForm = async () => {
    await axiosInstanceAuth
      .get("/viewallsubmitform")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllViewForm(myData?.data?.Forms);
        console.log("viewallsubmitform Form---->", myData?.data?.Forms);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getViewallSubmitForm();
    setIsOpenEdit(true);
    getFormsData();
  }, []);

  const [showEditAll, setShowEditAll] = useState(false);
  const toggleShowEditForm = () => {
    setShowEditAll(!showEditAll);
  };

  const displayEditTemplates = showEditAll
    ? allViewForm
    : allViewForm?.slice(0, 4);

  const [getEditId, setGetEditId] = useState("");
  const [dateVersion, setDateVersion] = useState();

  // Template single ID  API
  const getFormsEditApi = async (getEditId) => {
    setGetEditId(getEditId);
    await axiosInstanceAuth
      .get(`/view_singlesubmitform/${getEditId}`)
      .then((res) => {
        const myTemplateID = decryptData(res?.data?.data);
        console.log("Template Edit ID Done Forms--->", myTemplateID);
        const fileUrl = `${BACKEND_BASE_URL}${myTemplateID?.data?.submitedHtml}`;
        setDateVersion(myTemplateID);
        console.log("FileURl---->", fileUrl);

        fetch(fileUrl)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], myTemplateID.fileName, {
              type: blob.type,
            });
            setFile(file);
            if (myTemplateID?.status) {
              setSecond(true);
            }
            handleFileUploadEdit(file);
          })
          .catch((error) => {
            console.error("Error fetching the file:", error);
          });
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const displayedTemplates = showAll ? allForms : allForms?.slice(0, 4);

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const docxFile = event.target.result;
      const { value } = await mammoth.convertToHtml({ arrayBuffer: docxFile });
      setDocxContent(value);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownload = async (templateId) => {
    const response = await axiosInstanceAuth.get(`downloadpdf/${templateId}`);

    const filePath = decryptData(response?.data?.data);
    const generatelink = `${BACKEND_BASE_URL}${filePath?.data?.path}`;
    fetch(generatelink) // Replace with the appropriate URL
      .then((response) => {
        console.log("🚀 ~ .then ~ response:", response);
        if (response.status) {
          return response.blob();
        } else {
          throw new Error("Failed to download PDF");
        }
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filePath?.data?.name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  const handleTableRowClick = (templateId) => {
    getFormsEditApi(templateId);
    setIsOpenEdit(!isOpenEdit);
    setIsOpen(!isOpen);
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-animation flex justify-center items-center min-h-screen ">
          <PropagateLoader color="#22345C" />
        </div>
      ) : (
        <>
          {isOpenEdit && (
            <>
              {displayEditTemplates && displayEditTemplates.length > 0 && (
                <>
                  <div className="p-1.5 flex justify-between items-center ">
                    <div className="text-[#6F6F6F] font-sans font-semibold text-lg">
                      Recent Accessed Templates{" "}
                    </div>
                    {!showEditAll && (
                      <div
                        onClick={toggleShowEditForm}
                        className="text-[#22345C] font-sans font-semibold underline"
                      >
                        View All{" "}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <div className="overflow-x-auto">
                      <div className="p-1.5 w-full inline-block align-middle">
                        <div className="overflow-hidden border border-black rounded-lg bg-white">
                          <table className="min-w-full divide-y divide-black">
                            <thead className="">
                              <tr>
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-base font-bold text-left font-sans"
                                >
                                  Name
                                </th>
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-base font-bold text-left font-sans "
                                >
                                  Last Edit
                                </th>
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-base font-bold text-left font-sans "
                                >
                                  Edit By
                                </th>
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-base text-center font-bold  font-sans "
                                >
                                  Version
                                </th>
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-base text-center  font-sans "
                                >
                                  Download
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-black">
                              {/* {displayEditTemplates?.length > 0 && */}
                              {displayEditTemplates.map((d, index) => (
                                <>
                                  <tr
                                    key={index}
                                    className="hover:bg-[#22345C] hover:text-white cursor-pointer"
                                    onClick={() => handleTableRowClick(d._id)}
                                  >
                                    <td className="flex items-center gap-2 px-6 py-2 text-base font-bold font-sans  whitespace-nowrap">
                                      <div>
                                        <img
                                          src={`${BACKEND_BASE_URL}${d?.image}`}
                                          // src={`${BACKEND_BASE_URL}${i?.image}`}
                                          alt=""
                                          className="w-10 h-10  rounded-lg border border-black"
                                        />
                                      </div>
                                      <div>{d.title}</div>
                                    </td>
                                    <td className="px-6 py-2 text-base font-bold font-sans  whitespace-nowrap">
                                      {d.submiteddate}
                                    </td>
                                    <td className="px-6 py-2 text-base font-bold font-sans  whitespace-nowrap">
                                      {d.edit_by}
                                    </td>
                                    <td className="px-6 py-2 text-base text-center font-bold font-sans  whitespace-nowrap">
                                      {d.version}
                                    </td>
                                    <td className="p-1.5 ">
                                      <div className="relative gap-2 flex items-center justify-center  ">
                                        <div>
                                          <HiDownload
                                            onClick={(e) => {
                                              e.stopPropagation(); // Prevents the row click event from being triggered
                                              handleDownload(d._id);
                                            }}
                                            size={25}
                                            className="cursor-pointer rounded-[3px] "
                                          />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {second && (
            <div>
              <DocxConverterEdit
                setSecond={setSecond}
                editId={getEditId}
                isOpenEdit={isOpenEdit}
                setIsOpenEdit={setIsOpenEdit}
                savedContentEdit={savedContentEdit}
                setSavedContentEdit={setSavedContentEdit}
                docxContentEdit={docxContentEdit}
                setDocxContentEdit={setDocxContentEdit}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                Final={allViewForm}
                dateVersion={dateVersion}
                setIsLoading={setIsLoading}
                getViewallSubmitForm={getViewallSubmitForm}
                setDocxContent={setDocxContent}
                setSavedContent={setSavedContent}
                setMytemplateIDData={setMytemplateIDData}
                setShowAll={setShowAll}
                showAll={showAll}
              />
            </div>
          )}

          {isOpen && (
            <>
              <div className="my-5 ">
                <div className="flex gap-5 justify-between">
                  <div className="flex gap-1 relative text-[30px] justify-center font-bold text-[#22345C]">
                    <h1>Template / </h1>
                    <h1>Forms </h1>
                  </div>

                  {!showAll && (
                    <div
                      onClick={toggleShowAll}
                      className=" text-end gap-1 cursor-pointer
               text-[18px] text-[#22345C]   font-bold underline underline-offset-4"
                    >
                      View All Templates
                    </div>
                  )}
                </div>
              </div>

              <div className="grid lg:grid-cols-4  grid-cols-2 gap-10 mt-5 mb-5">
                {displayedTemplates?.length > 0 &&
                  displayedTemplates.map((i, index) => (
                    <div
                      onClick={() => {
                        getFormsIDApi(i._id);
                        setIsOpen(!isOpen);
                        setIsOpenEdit(false);
                      }}
                      key={index}
                      className="justify-between cursor-pointer transition duration-300 ease-in-out hover:scale-105 hover:border-[2px] hover:border-black items-center text-[#666666] bg-[#FFFFFF] p-5 rounded-[10px] border-gray-400 "
                    >
                      <div className="border-[1.5px] border-black rounded-md p-1">
                        <img
                          src={`${BACKEND_BASE_URL}${i?.image}`}
                          alt=""
                          className="w-full h-72"
                        />
                      </div>
                      <div className="items-center mt-3 text-center h-8  space-y-4">
                        <p className="font-sans font-bold text-[#2B2B2B] text-[18px]">
                          Folder Name : {i.FolderName}
                        </p>
                        <p className="font-sans font-bold underline underline-offset-4 text-[#2B2B2B] text-[18px]">
                          {i.title}
                        </p>
                      </div>

                      <div class="flex flex-wrap justify-center gap-6 pt-20">
                        <div class="relative " href="#">
                          <span class="absolute top-0 left-0 mt-1 ml-1 h-full w-full rounded-[10px] bg-black"></span>
                          <span
                            // onClick={() => getFormsdata(i.filename)}
                            class="fold-bold relative inline-block h-full w-full rounded-[10px] bg-[#22345C] px-3 py-2 text-base font-bold text-white transition duration-100"
                          >
                            Get This Template
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
          {add && (
            <div>
              <DocxConverter
                setadd={setadd}
                id={getId}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                savedContent={savedContent}
                setSavedContent={setSavedContent}
                docxContent={docxContent}
                setDocxContent={setDocxContent}
                mytemplateIDData={mytemplateIDData}
                setIsOpenEdit={setIsOpenEdit}
                setAllForms={setAllForms}
                setIsLoading={setIsLoading}
                dateVersionDocx={dateVersionDocx}
                getFormsData={getFormsData}
                getViewallSubmitForm={getViewallSubmitForm}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Forms;
